import { render, staticRenderFns } from "./cardHeader.vue?vue&type=template&id=3c373c01&"
import script from "./cardHeader.vue?vue&type=script&lang=js&"
export * from "./cardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c373c01')) {
      api.createRecord('3c373c01', component.options)
    } else {
      api.reload('3c373c01', component.options)
    }
    module.hot.accept("./cardHeader.vue?vue&type=template&id=3c373c01&", function () {
      api.rerender('3c373c01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/cardHeader.vue"
export default component.exports